"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var VSearchInput_vue_1 = __importDefault(require("../scraps/VSearchInput.vue"));
var event_bus_1 = require("../../event-bus");
var vue_class_component_1 = __importStar(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var DistrictSelect_vue_1 = __importDefault(require("../form/DistrictSelect.vue"));
var UnitSelect_vue_1 = __importDefault(require("../form/UnitSelect.vue"));
var PermissionsMixin_1 = __importDefault(require("../../mixins/request/PermissionsMixin"));
var CreateScout_vue_1 = __importDefault(require("./CreateScout.vue"));
var LastModifiedInput_vue_1 = __importDefault(require("../form/LastModifiedInput.vue"));
var __ = window.$lang;
var TopMenu = /** @class */ (function (_super) {
    __extends(TopMenu, _super);
    function TopMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.search = "";
        return _this;
    }
    TopMenu.prototype.onSearchInputEnter = function () {
        event_bus_1.EventBus.$emit(event_bus_1.events.common.search.hit);
    };
    TopMenu.prototype.updateCurrentDistrict = function (option) {
        event_bus_1.EventBus.$emit(event_bus_1.events.district.change, {
            id: option.value,
            name: option.name
        });
    };
    TopMenu.prototype.updateCurrentUnit = function (option) {
        event_bus_1.EventBus.$emit(event_bus_1.events.unit.change, {
            id: option.value,
            name: option.name
        });
    };
    TopMenu.prototype.onArchivedChange = function (value) {
        event_bus_1.EventBus.$emit(event_bus_1.events.scout.archived, value);
    };
    TopMenu.prototype.onDisplayStateChange = function (value) {
        event_bus_1.EventBus.$emit(event_bus_1.events.scout.displayState, value);
    };
    TopMenu.prototype.onLastModifiedChange = function (value) {
        event_bus_1.EventBus.$emit(event_bus_1.events.district.last_modified.update, value);
    };
    TopMenu.prototype.onLastModifiedKeyDown = function (keyCode) {
        if (keyCode === 13) {
            event_bus_1.EventBus.$emit(event_bus_1.events.district.last_modified.accept);
        }
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], TopMenu.prototype, "districts", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], TopMenu.prototype, "currentDistrict", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], TopMenu.prototype, "units", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], TopMenu.prototype, "currentUnit", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], TopMenu.prototype, "archived", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], TopMenu.prototype, "displayState", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], TopMenu.prototype, "lastModified", void 0);
    TopMenu = __decorate([
        vue_class_component_1.default({ components: {
                CreateScout: CreateScout_vue_1.default,
                DistrictSelect: DistrictSelect_vue_1.default,
                UnitSelect: UnitSelect_vue_1.default,
                VSearchInput: VSearchInput_vue_1.default,
                LastModifiedInput: LastModifiedInput_vue_1.default
            } })
    ], TopMenu);
    return TopMenu;
}(vue_class_component_1.mixins(PermissionsMixin_1.default)));
exports.default = TopMenu;
